import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, catchError, filter, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class scrollTopService {
  menuList = new BehaviorSubject([]);
  constructor(private router: Router) {
    if(isPlatformBrowser(PLATFORM_ID)) {
      this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top
      });
    }
   }

}
